import React from 'react'
import ContactUs from '../components/ContactUs/ContactUs'

const Contact = () => {
  return (
    <div className='contact'>
        <ContactUs/>
    </div>
  )
}

export default Contact